import { SxProps, Theme } from '@mui/material';

/**
 * Wraps rather than scrolls: a patient with four therapists is rare but real, and a row
 * that grows downwards is readable where one that clips is not.
 */
export const therapistsBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.5,
    alignItems: 'center',
};

/** Same muted treatment a missing phone number gets -- an absence, not a value. */
export const noTherapistsStyles: SxProps<Theme> = {
    color: 'text.disabled',
};
